import { Local } from '@/utils/storage';
import type { TrackingEventData } from './types';

/**
 * 日志输出
 * @param debug 是否启用调试模式
 * @param args 日志参数
 */
export function log(debug?: boolean, ...args: any[]): void {
  if (debug) {
    console.log('[TrackingSDK]', ...args);
  }
}

/**
 * 设置队列数据
 * @param eventQueue 事件队列
 * @param storageName 存储名称
 * @returns 更新后的事件队列
 */
export const setQueueData = (
  eventQueue: TrackingEventData[],
  storageName: string,
): TrackingEventData[] => {
  Local.set(storageName, eventQueue);
  return eventQueue || [];
};

/**
 * 获取队列数据
 * @param storageName
 * @returns
 */
export const getQueueData = (storageName: string): TrackingEventData[] => {
  return Local.get(storageName) || [];
};

/**
 * 添加队列数据
 * @param storageName
 * @param data
 */
export const addQueueData = (storageName: string, data: TrackingEventData) => {
  const eventQueue = getQueueData(storageName);
  if (!eventQueue?.length || !eventQueue.some((item) => item.ramdomId === data.ramdomId)) {
    eventQueue.push(data);
    setQueueData(eventQueue, storageName);
  }
};

/**
 * 删除指定的数据
 * @param eventQueue  事件队列
 * @param storageName 存储名称
 * @param id 删除的数据id
 */
export const delQueueItem = (storageName: string, id: string): TrackingEventData[] => {
  const eventQueue = getQueueData(storageName);

  // 如果队列为空，直接返回空数组
  if (!eventQueue?.length) {
    return [];
  }

  // 过滤掉指定ID的项并更新存储
  const newEventQueue = eventQueue.filter((item) => item.ramdomId !== id);
  return setQueueData(newEventQueue, storageName);
};

/**
 * 上报数据
 * @param endpoint 上报地址
 * @param data 要上报的数据
 * @param log 日志函数
 */
export const flush = async (
  endpoint: string,
  data: TrackingEventData,
  logger?: (...args: any[]) => void,
): Promise<boolean> => {
  logger?.('上报埋点数据:', data);

  // 这里使用fetch API发送数据，实际项目中可能需要根据项目API调整
  let res = true;
  await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    keepalive: true, // 确保页面卸载时也能发送请求
  })
    .then((response) => response.text())
    .catch((error: any) => {
      logger?.('埋点数据上报失败:', error);
      res = false;
    });
  return res;
};
